import { render, staticRenderFns } from "./OutpatientStatistics.vue?vue&type=template&id=5257eee8&scoped=true&"
import script from "./OutpatientStatistics.vue?vue&type=script&lang=js&"
export * from "./OutpatientStatistics.vue?vue&type=script&lang=js&"
import style0 from "./OutpatientStatistics.vue?vue&type=style&index=0&lang=css&"
import style1 from "./OutpatientStatistics.vue?vue&type=style&index=1&id=5257eee8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5257eee8",
  null
  
)

export default component.exports